export default function (form, name, classes = [], data = {}) {
	data.form = name;
	data.fieldsGroup = name;
	return `
		${this.render('form/formOpen', form, name, classes, data)}
		${this.render('form/formContent', form)}
		${this.render('form/formClose')}
	`;
}
